import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label }) => (
  <div className="flex items-center gap-4 mb-6" data-testid={`chapter-${num}`}>
    <span className="h-px w-12 bg-primary/60" />
    <span className="text-xs sm:text-sm uppercase tracking-[0.2em] text-zinc-400 font-semibold">
      {label}
    </span>
  </div>
);

export const scrollToId = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
